export function getMainDomain(host) {
  return host.split(".").slice(-2).join(".");
}
export function getTopLevelDomain(host) {
  return host.split(".").slice(-1).join(".");
}
export function isAccountEnabled(url) {
  return [
    "nu.nl",
    "ad.nl",
    "alarmeringen.nl",
    "ariadneathome.nl",
    "autoweek.nl",
    "bd.nl",
    "bndestem.nl",
    "buienradar.be",
    "buienradar.nl",
    "comparateur-energie.be",
    "dagallemaal.be",
    "demorgen.be",
    "destentor.nl",
    "donaldduck.nl",
    "dpgmedia.be",
    "dpgmedia.nl",
    "dpgmedia.net",
    "ed.nl",
    "eigenhuiseninterieur.nl",
    "energie-vergelijker.be",
    "energyprice.be",
    "feelingwonen.be",
    "flair.nl",
    "fluister.be",
    "fluister.nl",
    "gelderlander.nl",
    "goedgevoel.be",
    "hln.be",
    "humo.be",
    "indebuurt.nl",
    "intermediair.nl",
    "joe.be",
    "joe.nl",
    "kidsweek.nl",
    "kiosk.be",
    "kiosk.nl",
    "libelle.nl",
    "leukstetickets.nl",
    "leukstetickets.be",
    "margriet.nl",
    "mijnenergie.be",
    "nationalevacaturebank.nl",
    "oudersvannu.nl",
    "parool.nl",
    "primo.be",
    "puzzelfit.be",
    "puzzelfit.nl",
    "pzc.nl",
    "qmusic.be",
    "qmusic.nl",
    "reclamefolder.nl",
    "rtl.nl",
    "shopmagazines.be",
    "sportnieuws.nl",
    "stijlvol-wonen.com",
    "story.be",
    "story.nl",
    "teveblad.be",
    "lezerij.be",
    "lezerij.nl",
    "tijdschrift.be",
    "tijdschrift.nl",
    "tina.nl",
    "totaaltv.nl",
    "trouw.nl",
    "tubantia.nl",
    "tvfamilie.be",
    "uitjekrant.nl",
    "veronicasuperguide.nl",
    "volkskrant.nl",
    "vtm.be",
    "vtmgo.be",
    "vtwonen.be",
    "vtwonen.nl",
    "willy.radio",
    "wonenlandelijkestijl.com",
    "zozitdat.nl",
    "7sur7.be"
  ].some((el) => url.includes(el));
}
